export enum FilesActionType {
  SET_FILES = 'SET_FILES',
  SET_FILES_PAGINATION = 'SET_FILES_PAGINATION',
}
